import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SelectBrandItem } from '../../../services/dashboard.service';
import { UtilService } from '../../../services/util.service';
import { ContentCategoryDistributionComponent } from '../../my-competition-screen/content-category-distribution/content-category-distribution.component';
import { ContentCategoryDistributionResponse } from '../../my-competition-screen/content-category-distribution/types/types';
import { AdTypeBrand, AdTypeDistribution } from '../types';
import { round } from '../../../utils/numbers';

@Component({
    selector: 'app-ad-type-distribution',
    imports: [ContentCategoryDistributionComponent],
    templateUrl: './ad-type-distribution.component.html',
    styleUrl: './ad-type-distribution.component.scss',
})
export class AdTypeDistributionComponent implements OnChanges {
    @Input() data: AdTypeDistribution | undefined;
    @Input() loading = false;
    @Input() myBrand!: SelectBrandItem;
    @Input() myCompetitors!: SelectBrandItem[];
    @Input() brandColorsMap: Record<string, string> = {};

    private utilService = inject(UtilService);
    protected contentCategoryData: ContentCategoryDistributionResponse | undefined;

    public isAdType = true;
    ngOnChanges(changes: SimpleChanges): void {
        if (changes['data']) {
            this.buildContentCategoryData();
        }
    }

    private buildContentCategoryData(): void {
        if (!this.data?.brands?.length) {
            this.contentCategoryData = undefined;
            return;
        }
        const mapped = this.data.brands.map(brand => ({
            brandKey: brand.key,
            shares: this.toShares(brand),
        }));
        const myBrandKey = this.myBrand?.key;
        const myBrandData = mapped.find(b => b.brandKey === myBrandKey) ?? { brandKey: myBrandKey, shares: {} };
        const sortedShares = Object.fromEntries(
            Object.entries(myBrandData.shares).sort(([, a], [, b]) => b - a)
        );
        this.contentCategoryData = {
            myBrand: { ...myBrandData, shares: sortedShares },
            myCompetitors: mapped.filter(b => b.brandKey !== myBrandKey),
        };
    }

    private toShares(brand: AdTypeBrand): Record<string, number> {
        const totals: Record<string, number> = {};
        for (const [adType, spend] of Object.entries(brand.spend)) {
            if (adType === 'total') continue;
            totals[adType] = (totals[adType] ?? 0) + spend;
        }
        const total = Object.values(totals).reduce((sum, v) => sum + v, 0);
        if (total === 0) return {};
        return Object.fromEntries(
            Object.entries(totals).map(([type, spend]): [string, number] => [
                this.utilService.formatTitles(type),
                this.showSpendInPrecentage(spend, total),
            ])
        );
    }
    private showSpendInPrecentage(spend: number, total: number) {
        return Number(round((spend / total) * 100, 1))
    }
}
